/* unplugin-vue-components disabled */import { render } from "./DIcon.vue?vue&type=template&id=4daaaef2"
import script from "./DIcon.vue?vue&type=script&lang=js"
export * from "./DIcon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\星网代码\\2018-05-18 路特利\\2022-02-23需求\\DM.LtlApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__